import { render, staticRenderFns } from "./Components2.vue?vue&type=template&id=b84f4c18&scoped=true"
import script from "./Components2.vue?vue&type=script&lang=js"
export * from "./Components2.vue?vue&type=script&lang=js"
import style0 from "./Components2.vue?vue&type=style&index=0&id=b84f4c18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84f4c18",
  null
  
)

export default component.exports